export default "__VITE_ASSET__6a62476c__"